import React from "react";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { cn } from "@/lib/utils";

const PhoneInput = React.forwardRef(
    ({ className, placeholder = "Enter phone number", value, onChange, ...props }, ref) => {
        // Debug: Log when component re-renders
        React.useEffect(() => {
            console.log('PhoneInput re-rendered with value:', value);
        }, [value]);

        // Memoize the input component to prevent re-renders
        const InputComponent = React.useMemo(() => 
            React.forwardRef((inputProps, inputRef) => (
                <input
                    {...inputProps}
                    ref={inputRef}
                    className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                />
            )), []
        );

        return (
            <PhoneInputWithCountrySelect
                ref={ref}
                international
                defaultCountry="US"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className={cn(
                    "phone-input",
                    className
                )}
                inputComponent={InputComponent}
                countrySelectProps={{
                    className: "country-select"
                }}
                style={{
                    "--PhoneInputCountryFlag-height": "1em",
                    "--PhoneInputCountryFlag-width": "1.5em",
                    "--PhoneInputCountrySelect-marginRight": "0.5rem",
                }}
                {...props}
            />
        );
    }
);

PhoneInput.displayName = "PhoneInput";

export { PhoneInput }; 